(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["celbari-swatches"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.celbariSwatches) return;
    window.celbariSwatches = true;

    const activate = (button) => {
      const card = button.closest('product-card');
      const wrap = button.closest('[data-celbari-swatches]');
      if (!card || !wrap) return;
      wrap.querySelectorAll('.celbari-swatch').forEach((s) => s.classList.toggle('is-active', s === button));

      const gallery = card.querySelector('.card-gallery');
      let preview = card.querySelector('.celbari-swatch-preview');
      if (button.hasAttribute('data-first') || !button.dataset.src || !gallery) {
        preview?.remove();
      } else {
        if (!preview) {
          preview = document.createElement('img');
          preview.className = 'celbari-swatch-preview';
          preview.alt = '';
          preview.sizes = '(min-width: 750px) 25vw, 45vw';
          gallery.append(preview);
        }
        preview.srcset = button.dataset.srcset;
        preview.src = button.dataset.src;
      }

      // open the product page on the chosen colour (keeps any search/tracking parameters)
      if (button.dataset.variantId) {
        card.querySelectorAll('a[href*="/products/"]').forEach((link) => {
          const url = new URL(link.href, location.origin);
          url.searchParams.set('variant', button.dataset.variantId);
          link.href = url.href;
        });
      }
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest?.('.celbari-swatch[data-variant-id]');
      if (!button) return;
      event.preventDefault();
      activate(button);
    });

    document.addEventListener('pointerover', (event) => {
      if (event.pointerType !== 'mouse') return;
      const button = event.target.closest?.('.celbari-swatch[data-variant-id]');
      if (button && !button.classList.contains('is-active')) activate(button);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
